import { performSilentOidcAuthWithFallbackToRedirect } from '@diligentcorp/library-oidc-client-frontend-helpers';
import { OIDC_AUTH_START_PATH } from '@issuemanager/infrastructure/constructs/oidc/constants';

export const performOidcSilentReauth = (
  resourceIndicator: string,
): Promise<void> =>
  performSilentOidcAuthWithFallbackToRedirect(
    new URL(OIDC_AUTH_START_PATH, window.location.origin),
    {
      resourceIndicator,
      postAuthRedirectPath: window.location.pathname + window.location.search,
      lockingStrategy: 'origin',
    },
  );
